import React, { PureComponent } from 'react';
import styles from './index.css';
/**
 * 视频loading组件
 */
class Loading extends PureComponent {
    render() {
        return (React.createElement("div", { className: styles.loadingBox },
            React.createElement("div", { className: styles.loadingbanner })));
    }
}
export default Loading;
